import { BankCardTagType } from '@/interface/KKC/edda';
import classNames from 'classnames';
import { t } from 'i18next';
import { ReactComponent as DefaultIcon } from './images/default_icon.svg';
import style from './index.module.less';

type propsType = {
  tag?: BankCardTagType;
  className?: string;
};

function BankCardTag(props: propsType) {
  const { tag, className } = props;
  const textMap = {
    [BankCardTagType.DEFAULT]: t('edda.bankcard.defaultTag'),
    [BankCardTagType.HANDLING]: t('edda.bankcard.handling'),
    [BankCardTagType.UNBINGDING]: t('edda.bankcard.unbinding'),
  };
  const layoutCls = classNames(className, style.layout, {
    [style.default_bg]: tag === BankCardTagType.DEFAULT,
    [style.other_bg]: tag === BankCardTagType.HANDLING || tag === BankCardTagType.UNBINGDING,
  });
  return tag !== undefined && tag !== BankCardTagType.NotDefault ? (
    <div className={layoutCls}>
      {tag === BankCardTagType.DEFAULT ? <DefaultIcon className={style.default_icon} /> : null}
      <span className={style.text}>{textMap[tag]}</span>
    </div>
  ) : (
    <div />
  );
}

export default BankCardTag;
